module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_540.475a6f55.jpg";